import { render, staticRenderFns } from "./1_to_m.vue?vue&type=template&id=4dabc04f&"
import script from "./1_to_m.vue?vue&type=script&lang=js&"
export * from "./1_to_m.vue?vue&type=script&lang=js&"
import style0 from "./1_to_m.vue?vue&type=style&index=0&id=4dabc04f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports